export default "__VITE_ASSET__04a70b5a__"